import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

type ContainerProps = {
  $isBackgroundActive?: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  align-self: stretch;

  min-inline-size: 160px;
  padding: 16px;

  border: 1px solid #4585ff;
  border-radius: 8px;

  background: ${props => (props.$isBackgroundActive ? "#ecf3ff" : "#fff")};
`;

export const IconWrapper = styled.div``;

export const Title = styled.div`
  color: #30343c;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: 130%;
  text-transform: uppercase;
`;

export const Description = styled.div`
  color: #30343c;
  font-weight: 400;
  font-size: 15px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: 130%;
`;
